import React, { useMemo, useEffect } from "react";
import { connect } from "react-redux";
import { fetch, setDadosPesq } from "../actions/index";
import { Checkbox } from "antd";
import { SubTitulo } from "./Diversos";
import { usePesq } from "./Hooks/Pesq";

function Func(props) {
  const [dados, loading] = usePesq(props.fetch, props.dados, props.setDadosPesq, "empresa");
  const { value, setValue } = props;

  useEffect(() => {
    setValue((dados.empresa || []).map(x => x.idEmpresa));
  }, [dados]);


  const [allChecked, indeterminate] = useMemo(() => {
    if (!value || value.length === 0) {
      return [false, false];
    }

    if (value.length >= dados.empresa.length) {
      return [true, false];
    } else {
      return [false, true];
    }
  }, [value]);

  const marcar = id => {
    if (!value) {
      setValue([id]);
      return;
    }

    if (value.includes(id)) {
      setValue(value.filter(x => x != id));
    } else {
      setValue([...value, id]);
    }
  };

  const checkAll = () => {
    setValue(!allChecked ? (dados.empresa || []).map(x => x.idEmpresa) : []);
  };

  return (
    <>
      {/* <pre>{JSON.stringify(value, null, 2)}</pre> */}
      <div style={{ padding: 4 }}>
        <Checkbox indeterminate={indeterminate} onChange={checkAll} checked={allChecked}>
          <SubTitulo>Lojas ({(value || []).length})</SubTitulo>
        </Checkbox>
      </div>
      <div className="select-lojas" style={{ maxHeight: props.maxHeight, overflowY: "auto" }}>
        {(dados.empresa || []).map(x => {
          const marca = (value || []).includes(x.idEmpresa);
          return (
            <div key={x.idEmpresa} className={marca ? "active" : null}>
              <Checkbox checked={marca} onClick={() => marcar(x.idEmpresa)}>
                {x.nome}
              </Checkbox>
            </div>
          );
        })}
      </div>
    </>
  );
}

const mapStateToProps = state => {
  return { dados: state.pesq };
};

export default connect(mapStateToProps, { fetch, setDadosPesq })(Func);
